import React from "react";
import { useParams, useLoaderData } from "react-router-dom";
import { FullPagePaperLayout } from "../Layouts/FullPagePaperLayout";
import { PageBreadcrumbs, PageSubtitle, PageTitle } from "../Layouts/components/PageTitleContainer";
import { Stack, Button, Select, MenuItem, Box } from "@mui/material";
import { AllowedMovement } from "types/locationManagement/allowedMovement";
import { LocationManagementLocationType } from "types/locationManagement/locationType";
import { FieldControl } from "components/Form/FieldControl";
import { Form } from "components/Form/Form";

const AllowedMovementForm: React.FC = () => {
  const { allowedMovementId } = useParams<{ allowedMovementId?: string }>();
  const isEdit = Boolean(allowedMovementId);
  const { allowedMovement, locationTypes } = useLoaderData() as {
    allowedMovement: AllowedMovement;
    locationTypes: LocationManagementLocationType[];
  };

  return (
    <FullPagePaperLayout>
      <PageBreadcrumbs
        links={[
          { label: "Admin", path: "/" },
          { label: "Allowed Movements", path: "/allowed-movements" },
        ]}
      />
      <PageTitle>{isEdit ? "Edit" : "Create"} Allowed Movement</PageTitle>
      <PageSubtitle>
        Define which movements are allowed between location types. By default, inventory can move freely — use allowed
        movements to explicitly permit moves between specific location types.
      </PageSubtitle>
      <Box sx={{ m: 3 }}>
        <Form method={isEdit ? "PUT" : "POST"} resource="allowedMovement">
          <Stack direction="column" spacing={2}>
            <FieldControl
              name="fromLocationTypeId"
              label="From Location Type"
              inputProps={{
                defaultValue: allowedMovement.fromLocationType?.id || allowedMovement.fromLocationTypeId || "",
              }}
            >
              {({ name, label, defaultValue, labelId }) => (
                <Select name={name} labelId={labelId} defaultValue={defaultValue} label={label}>
                  <MenuItem value="">Any Location Type</MenuItem>
                  {locationTypes.map((locationType) => (
                    <MenuItem key={locationType.id} value={locationType.id}>
                      {locationType.name}
                    </MenuItem>
                  ))}
                </Select>
              )}
            </FieldControl>
            <FieldControl
              name="toLocationTypeId"
              label="To Location Type"
              inputProps={{
                defaultValue: allowedMovement.toLocationType?.id || allowedMovement.toLocationTypeId || "",
              }}
            >
              {({ name, label, defaultValue, labelId }) => (
                <Select name={name} labelId={labelId} defaultValue={defaultValue} label={label}>
                  <MenuItem value="">Any Location Type</MenuItem>
                  {locationTypes.map((locationType) => (
                    <MenuItem key={locationType.id} value={locationType.id}>
                      {locationType.name}
                    </MenuItem>
                  ))}
                </Select>
              )}
            </FieldControl>
            <div>
              <Button type="submit" variant="contained">
                {isEdit ? "Update" : "Create"}
              </Button>
            </div>
          </Stack>
        </Form>
      </Box>
    </FullPagePaperLayout>
  );
};

export default AllowedMovementForm;
